(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('Callout', Callout);

  function Callout(CalloutLabelService){

    return {
      labelValueConfig: labelValueConfig,
      tfUsersConfig: tfUsersConfig,
      usedForReportingConfig: usedForReportingConfig,
      liftConfig: liftConfig,
      metricChangeConfig: metricChangeConfig,
      topMainSubLabelConfig: topMainSubLabelConfig
    };

    function labelValueConfig(section) {
      return {
        section: section,
        template: 'StandardReports/Callout/LabelValueCallout.tmpl.html'
      }
    }

    function tfUsersConfig(section) {
      return {
        section: section,
        template: 'StandardReports/Callout/TFUsersCallout.tmpl.html'
      }
    }

    function usedForReportingConfig(section) {
      return {
        section: section,
        template: 'StandardReports/Callout/UsedForReportingCallout.tmpl.html'
      }
    }

    function liftConfig(section) {
      return {
        section: section,
        template: 'StandardReports/Callout/LiftCallout.tmpl.html'
      }
    }

    function metricChangeConfig(section) {

      return {
        section: section,
        template: 'StandardReports/Callout/MetricChangeCallout.tmpl.html'
      }
    }


    function topMainSubLabelConfig(section, mainLabel, subLabels, fetchDataFunc) {
      return {
        section: section,
        mainLabel: mainLabel,
        subLabels: subLabels,
        fetchData: fetchDataFunc
      }
    }

  }
})();